import { useTranslation } from 'react-i18next'

import { Field } from '../../Field'

import * as styles from './SettingsField.module.css'

function SettingsField({
  className = styles.SettingsField,
  fieldInputClassName = styles.fieldInput,
  label,
  labelClassName = styles.label,
  labelKey,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Field
      {...restProps}
      className={className}
      fieldInputClassName={fieldInputClassName}
      label={labelKey ? t(labelKey) : label}
      labelClassName={labelClassName}
    />
  )
}

export default SettingsField
